module.exports = __webpack_public_path__ + "img/illegal.bd127108.jpg";